import { VehiclePanelOption } from "src/app/shared/models/configuration";

export const vehiclePanelOptions: VehiclePanelOption = {
  verImei: {
    id: 'verImei',
    variant: 'imei',
    enabled: false,
    visible: true,
  },
  numSim: {
    id: 'numSim',
    variant: 'numSim',
    enabled: false,
    visible: true,
  },
  verColor: {
    id: 'verColor',
    variant: 'color',
    enabled: true,
    visible: true,
  },
  verIgnition: {
    id: 'verIgnition',
    variant: 'ignition',
    enabled: false,
    visible: true,
  },
  verSpeed: {
    id: 'verSpeed',
    variant: 'speed',
    enabled: true,
    visible: true,
  },
  verBaterryVoltage: {
    id: 'verBaterryVoltage',
    variant: 'batteryVoltage',
    enabled: false,
    visible: true,
  },
  verAmountOfFuel: {
    id: 'verAmountOfFuel',
    variant: 'amountOfFuel',
    enabled: false,
    visible: true,
  },
  verTimeElapsed: {
    id: 'verTimeElapsed',
    variant: 'timeElapsed',
    enabled: true,
    visible: true,
  },
  verSatellite: {
    id: 'verSatellite',
    variant: 'satellite',
    enabled: false,
    visible: true,
  },
  verTemperaturaBle: {
    id: 'verTemperaturaBle',
    variant: 'temperature-ble',
    enabled: false,
    visible: true,
  },
  verTemperaturaEye: {
    id: 'verTemperaturaEye',
    variant: 'temperature-eye',
    enabled: false,
    visible: true,
  },
  verHumedadBle: {
    id: 'verHumedadBle',
    variant: 'humidity-ble',
    enabled: false,
    visible: true,
  },
  verHumedadEye: {
    id: 'verHumedadEye',
    variant: 'humidity-eye',
    enabled: false,
    visible: true,
  },
  verIconVehicle: {
    id: 'verIconVehicle',
    variant: 'icon',
    enabled: true,
    visible: true,
  },
  ver: {
    id: 'ver',
    variant: 'see',
    enabled: true,
    visible: true,
  },
  verTransmissionStatus: {
    id: 'verTransmissionStatus',
    variant: 'transmissionStatus',
    enabled: true,
    visible: true,
  },
  verDriver: {
    id: 'verDriver',
    variant: 'driver',
    enabled: false,
    visible: true,
  },
  verName: {
    id: 'verName',
    variant: 'nameButton',
    enabled: false,
    visible: true,
  },
  verFollowUnit: {
    id: 'verFollowUnit',
    variant: 'followUnitButton',
    enabled: true,
    visible: true,
  },
  verEye: {
    id: 'verEye',
    variant: 'eye',
    enabled: true,
    visible: true,
  },
};
